import { useQuery } from '@connectrpc/connect-query'
import { getCompanyInfo } from '@ebalance/proto/bffuser/v1/company_info_service-CompanyInfoService_connectquery'

/** 会社情報 (登録小売電気事業者 ID + 名称) の取得状態。 */
export type CompanyInfoState = {
  isLoading: boolean
  /** 取得に失敗したか (= 未登録扱いで UI 非活性、画面自体は描画継続)。 */
  isError: boolean
  /** 会社情報カードが登録済みか。 未登録なら排出係数紐付け UI を非活性 (AC-BSP-087)。 */
  registered: boolean
  /** 登録小売電気事業者 ID (5 文字英数)。 未登録 / 取得前は空文字。 */
  retailerId: string
  /** 登録小売電気事業者名 (契約名義)。 未登録 / 取得前は空文字。 */
  name: string
}

/**
 * 自社の会社情報 (admin-hub.md §2 会社情報カード) を BFF `GetCompanyInfo` から取得する。
 *
 * 2 画面で使う:
 * - システム管理トップの会社情報カード (`pages/AdminHub`、AC-AHB-003〜005)
 * - 排出係数紐付けの判別コメント組み立て (`pages/SpotBidding`、spot-bidding.md §7)
 *
 * 取得エラー時は未登録扱い (= UI 非活性、 誤った ID でのコメント組み立てを防ぐ)。
 *
 * fail-safe: 上記のとおり取得エラー時の扱いが定義済みなので、 error boundary
 * (= 全画面エラー) に飛ばさない。 global QueryClient の `throwOnError: true` を本 query
 * だけ `false` に上書きする。
 */
export function useCompanyInfo(): CompanyInfoState {
  const { data, isLoading, isError } = useQuery(getCompanyInfo, undefined, {
    throwOnError: false,
  })
  const info = data?.companyInfo
  return {
    isLoading,
    isError,
    registered: info !== undefined && info.retailerId !== '',
    retailerId: info?.retailerId ?? '',
    name: info?.name ?? '',
  }
}
